export type Department =
  | 'Executive Management'
  | 'Operations'
  | 'Supply Chain & Logistics'
  | 'Customer Service'
  | 'Manufacturing'
  | 'Engineering'
  | 'Maintenance'
  | 'Quality & Food Safety'
  | 'Health, Safety & Environment (HSE)'
  | 'Research & Development (R&D)'
  | 'Procurement & Purchasing'
  | 'Human Resources (HR)'
  | 'Legal & Compliance'
  | 'Finance'
  | 'Information Technology (IT)'
  | 'Sales & Marketing'
  | 'Other'
  | 'Corporate Communications'
  | 'Administrative Support'

export const getDepartment = (department: string): Department => {
  switch (department) {
    case 'General Management':
    case 'Executive Board':
    case 'Executive Committee':
    case 'Operating Board Europe':
    case 'Leadership Team Europe':
    case 'BNL Leadership Team':
    case 'GER Leadership Team':
    case 'IBE Leadership Team':
    case 'ITA Leadership Team':
    case 'FIN Leadership Team':
    case 'POL Leadership Team':
    case 'FRA Leadership Team':
    case 'UK Leadership Team':
    case 'Leadership Team North-America':
    case 'Leadership Team Asia-Pacific':
    case 'AUS Leadership Team':
    case 'Operating Board North-America':
    case 'Operating Board Asia-Pacific': {
      return 'Executive Management'
    }
    case 'BNL Site Management':
    case 'GER Site Management':
    case 'IBE Site Management':
    case 'ITA Site Management':
    case 'FIN Site Management':
    case 'POL Site Management':
    case 'FRA Site Management':
    case 'UK Site Management':
    case 'AUS Site Management':
    case 'Operations': {
      return 'Operations'
    }
    case 'Demand & Supply Chain Management':
    case 'Supply Chain':
    case 'Planning':
    case 'Logistics':
    case 'Warehousing':
    case 'Demand & Supply Chain':
    case 'Supply Chain Logistics':
    case 'Supply Chain Planning':
    case 'Warehouse': {
      return 'Supply Chain & Logistics'
    }
    case 'Customer Service': {
      return 'Customer Service'
    }
    case 'Manufacturing':
    case 'Production': {
      return 'Manufacturing'
    }
    case 'Engineering':
    case 'Continuous improvement':
    case 'Technical': {
      return 'Engineering'
    }
    case 'Maintenance': {
      return 'Maintenance'
    }
    case 'QESH':
    case 'Quality': {
      return 'Quality & Food Safety'
    }
    case 'Safety':
    case 'Sustainability':
    case 'Health & Safety':
    case 'Health, Safety & Environment': {
      return 'Health, Safety & Environment (HSE)'
    }
    case 'R&D - Product Development':
    case 'Research & Development': {
      return 'Research & Development (R&D)'
    }
    case 'Procurement':
    case 'Purchasing':
    case 'Purchasing/Procurement': {
      return 'Procurement & Purchasing'
    }
    case 'Legal & HR':
    case 'HR':
    case 'Human Resources': {
      return 'Human Resources (HR)'
    }
    case 'Legal': {
      return 'Legal & Compliance'
    }
    case 'Finance':
    case 'Finance & IT':
    case 'Finance/Accounting':
    case 'Finance Accounting/Report':
    case 'Control':
    case 'Accounting': {
      return 'Finance'
    }
    case 'IT':
    case 'Information Systems':
    case 'Information Technology': {
      return 'Information Technology (IT)'
    }
    case 'Commercial & Marketing':
    case 'Commercial':
    case 'Marketing':
    case 'Category Management':
    case 'Commercialization':
    case 'Commerce':
    case 'Sales':
    case 'Sales & Marketing': {
      return 'Sales & Marketing'
    }
    case 'Other':
    case 'Print Production Group': {
      return 'Other'
    }
    case 'Communications': {
      return 'Corporate Communications'
    }
    case 'Support':
    case 'Administration': {
      return 'Administrative Support'
    }

    default: {
      console.log(`no department for: ${department}`)
      return 'Other'
    }
  }
}
